module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filters":"Filters","title":"Update your Search","yourSearch":"Your search"}}')
  delete Component.options._Ctor
}
